export const country = (raw) => ({
  isoCode: raw.iso_code,
  code: raw.code,
  name: raw.name,
  restricted: raw.restricted,
  id: raw.code,
});



// WEBPACK FOOTER //
// ../src/resources/countries/normalize.js